<template>
  <div>
    <a-spin :spinning="false">
      <div class="neo-tabs-classes">
        <a-tabs :defaultActiveKey="0" :tabPosition="this.settings['isMobileView'] ? 'top' : 'left'" @change="handleClassChange">
          <a-tab-pane :key="0">
            <span slot="tab">
              Select Class
            </span>

            <div class="">
              <p class="font-weight-bold text-primary">Select a class to manage final results settings!</p>
            </div>
          </a-tab-pane>
          <a-tab-pane v-for="schoolClass in schoolClasses" :key="schoolClass.id">
            <span slot="tab">
              Class: {{ schoolClass.name }}
            </span>
            <final-result-setting-form :settingData="finalsettings" :session="session" :selectedClass="selectedClass" @savedFinalSetting="handleSettingsSaved" @loaded="handleDataLoaded"/>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-spin>
  </div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'

import FinalResultSettingForm from '@/components/exam/final/Form/index'

export default {

  name: 'FinalResultListTable',
  components: {
    FinalResultSettingForm,
  },
  props: {
    loading: Boolean,
    schoolClasses: {
      type: Array,
      default: () => [],
    },
    session: Number,
  },
  data: function() {
    return {
      loadingData: false,
      selectedClass: null,
      finalsettings: [],
    }
  },
  computed: {
    ...mapState(['settings']),
  },
  methods: {
    moment,
    handleClassChange(classId) {
      // this.loadingData = true
      this.selectedClass = this.schoolClasses.filter((schoolClass) => schoolClass.id === classId)[0]
      if (classId === 0) {
        this.loadingData = false
      }
      this.getFinalResultSettings()
    },
    getFinalResultSettings: function() {
      this.loading = true
      this.$http.get('/api/finalresultsetting', {
        params: {
          session_id: this.selectedSession,
          class_id: this.selectedClass.id,
        },
      }).then(({ data }) => {
        this.loading = false
        this.finalsettings = data.data
        console.log(this.finalsettings)
      })
    },
    handleSettingsSaved() {
      this.getFinalResultSettings()
    },
    handleDataLoaded() {
      this.loadingData = false
    },
  },
}
</script>
